/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import SyncToolLoader from 'DesignSystem/SyncToolLoader/react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content/SyncPatients/Loading"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SyncToolLoader
  viewPath={`${viewPath}/SyncToolLoader`}
/>
<div
  data-testid="Loading.Vertical:1"
  data-view-path={viewPath}
 style={{'--mb-1-2mx3jB': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsBlack}
 weight="medium"
 marginBottom={dtSpaceMs}
 text="Syncing in progress..."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="App records compared with Greyfinch will show once the sync is complete. Please wait a few moments."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="until sync is complete."
/>
</div>
</div>
{children}
</React.Fragment>)
}